export const API_GET_IWOCAPAY_PAY_LINKS = `api/GET_IWOCAPAY_PAY_LINKS`;

export const API_GET_IWOCAPAY_CAPTURED_PAYMENTS = `api/GET_IWOCAPAY_CAPTURED_PAYMENTS`;
